<template>
  <div v-if="text || $slots.default" class="text-overlay" @click.self="close">
    <header class="text-overlay__head">
      <span class="text-overlay__badge">
        <svg
          class="text-overlay__badge-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 2 2 7l10 5 10-5-10-5z"></path>
          <path d="m2 12 10 5 10-5"></path>
          <path d="m2 17 10 5 10-5"></path>
        </svg>
        <span>Activity</span>
      </span>
      <button class="text-overlay__close" type="button" title="关闭" @click="close">
        <i class="el-icon-close"></i>
      </button>
    </header>

    <div class="text-overlay__scroll">
      <div class="text-overlay__card" :style="{ maxWidth: maxWidth + 'px' }">
        <div v-if="text" class="text-overlay__content">{{ text }}</div>
        <slot v-else></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CosmoClawTextOverlay',
  props: {
    // 纯文本内容（思考 / 过程叙述）；用默认插槽时可留空
    text: { type: String, default: '' },
    // 卡片最大宽度（工具详情等较宽内容可放大）
    maxWidth: { type: Number, default: 680 }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown(e) {
      if (e.key === 'Escape') this.close()
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.text-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  background: #f5f6f8;
}

.text-overlay__head {
  position: relative;
  flex-shrink: 0;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}

.text-overlay__badge {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #5f6470;
  user-select: none;
}

.text-overlay__badge-icon {
  width: 12px;
  height: 12px;
  color: #5f6470;
}

.text-overlay__close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 26px;
  height: 26px;
  border: 0;
  background: transparent;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b919c;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: rgba(15, 23, 42, 0.06);
    color: #3f4450;
  }
}

.text-overlay__scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  padding: 0 24px 48px;
}

.text-overlay__card {
  margin: auto;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);
  padding: 28px 32px;
}

.text-overlay__content {
  font-size: 13px;
  line-height: 1.85;
  color: #33373f;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
